// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "-" + {"959": "0d048f2a63a44558","975": "0b57422130437c27",}[chunkId] + ".js"
}